// client/src/components/ui/NotificationContainer.jsx

import React from 'react';
import Notification from './Notification';
import './Notification.css';

const NotificationContainer = ({ notifications, removeNotification }) => {
  // Trier les notifications pour que les plus récentes soient en haut
  const sortedNotifications = [...notifications].sort((a, b) => b.timestamp - a.timestamp);
  
  return (
    <div className="notification-container">
      {sortedNotifications.map(notification => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          duration={notification.duration}
          onClose={() => removeNotification(notification.id)}
          isVisible={true}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;